// Two-line coverage-period cell for the InsuranceTab table: dotted range on
// top, tonal meta line beneath. Tone is supplied by formatCoverage; archived
// rows pass isHistorical=true so the past-expiry tone demotes to muted.

import {
  formatCoverage,
  type CoverageTone,
} from "../../../../utils/formatCoverage";

interface CoveragePeriodCellProps {
  startDate: string;
  expiryDate: string;
  reminderDays?: number[];
  isHistorical?: boolean;
}

const TONE_CLASS: Record<CoverageTone, string> = {
  muted: "text-slate-400 dark:text-slate-500",
  success: "text-emerald-600 dark:text-emerald-400",
  warning: "text-amber-600 dark:text-amber-400",
  brand: "text-brand-600 dark:text-brand-400",
  danger: "text-red-600 dark:text-red-400 font-medium",
  neutral: "text-slate-700 dark:text-slate-200",
};

export default function CoveragePeriodCell({
  startDate,
  expiryDate,
  reminderDays,
  isHistorical = false,
}: CoveragePeriodCellProps) {
  const { range, meta, tone } = formatCoverage({
    startDate,
    expiryDate,
    reminderDays,
    isHistorical,
  });

  return (
    <div className="flex flex-col">
      <span className="text-body text-slate-900 dark:text-slate-100">
        {range}
      </span>
      <span className={`text-caption ${TONE_CLASS[tone]}`}>{meta}</span>
    </div>
  );
}
